import { useUserPreferences } from '@/src/hooks/use-user-preference-port/useUserPreferencePort'
import { userPreferencesPort } from '@/infra/config/beans'
import { useOutletContext, useNavigate } from 'react-router-dom'
import { Suspense } from 'react'
import FamilyCardListSkeleton from '@/src/components/global/family-card-list-skeleton/FamilyCardListSkeleton'
import { useSuspenseQuery } from '@tanstack/react-query'
import TeamFamilyCard from '@/src/components/my-team/team-family-card/TeamFamilyCard'
import { getTeams } from '@/infra/api/generated/teams/teams'
import { trackEvent } from '@/src/analytics/amplitude'

const { getTeamDiagnoses } = getTeams()

const allTeamDiagnosisQuery = (storeId: number, teamId: number, periodValue: string) => ({
  queryKey: ['diagnoses', 'history', storeId, teamId, periodValue],
  queryFn: () => getTeamDiagnoses(storeId, teamId, { periodValue: periodValue }),
})

export const Diagnoses = () => {
  const { team, store } = useUserPreferences(userPreferencesPort)
  const { month } = useOutletContext<{ month: string }>()

  return (
    <div className="flex flex-col gap-4">
      <Suspense fallback={<VendorHistorySkeleton />}>
        <DiagnosesContent storeId={store!.id} teamId={team!.id} month={month} />
      </Suspense>
    </div>
  )
}

interface HistoryContentProps {
  storeId: number
  teamId: number
  month: string
}

const DiagnosesContent = ({ storeId, teamId, month }: HistoryContentProps) => {
  const { data: vendorHistory } = useSuspenseQuery(allTeamDiagnosisQuery(storeId, teamId, month))
  const navigate = useNavigate()
  const handleFamilyCardClick = (diagnosisId: string) => {
    trackEvent('CONTINUE_ACTION_PLAN_BUTTON_CLICK', {
      diagnosisId,
      source: 'my-team/diagnoses',
    })
    void navigate(`/diagnoses/${diagnosisId}/actions`, { state: { source: 'myteam' } })
  }
  return (
    <div className="flex flex-col gap-3">
      {vendorHistory.map((hist) => (
        <TeamFamilyCard
          key={hist.diagnosisId}
          userId={hist.userId}
          family={hist.family}
          score={hist.score}
          daysLeft={hist.daysLeft}
          diagnosisId={hist.diagnosisId}
          onClick={handleFamilyCardClick}
        />
      ))}
    </div>
  )
}

const VendorHistorySkeleton = () => {
  return <div className="flex flex-col gap-3">{<FamilyCardListSkeleton skeletonCount={4} />}</div>
}

export default Diagnoses
